import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=92d09e9a&"
import script from "./Authorization.vue?vue&type=script&lang=js&"
export * from "./Authorization.vue?vue&type=script&lang=js&"
import style0 from "./Authorization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports